import { render, staticRenderFns } from "./processInspectionEdit.vue?vue&type=template&id=8fa5f41c"
import script from "./processInspectionEdit.vue?vue&type=script&lang=js"
export * from "./processInspectionEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports